import type { TenantConfig } from '@/types/TenantConfig'

export const nordicmuseum: TenantConfig = {
  logo: 'assets/nordicmuseum/static/logo.svg',
  teaserImageSize: {
    width: 300,
    height: 300,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/nordicmuseum/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-100px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/nordicmuseum/static/fonts.css',
    },
  },
  i18nOverrides: {
    en: {
      loginForm: {
        loginHelpText:
          '<p>Please login using the email address and password of the <strong>primary account holder</strong>.<p>',
      },
    },
  },
}
